import Vue from "vue";

export const ReportSetting = {
  methods: {
     //TODO：查询全部报告信息设置
     async getReportSetting() {
        let res = await this.$http.get("/tenant/report/setting");
        return res;
      },
  

      //TODO： 修改报告信息设置
      async upReportSetting(obj) {
        let res = await this.$http.put("/tenant/report/setting", obj);
        if (res.code == 200) {
          this.$message({ message: res.msg, type: "success" });
        } else {
          this.$message.error(res.msg);
        }
        return res;
      },
   
  },
};
